

export const FETCH_VEHICLE_TRANSMISSIONTYPE_LIST = {
    START: 'FETCH_VEHICLE_TRANSMISSIONTYPE_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_TRANSMISSIONTYPE_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_TRANSMISSIONTYPE_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_TRANSMISSIONTYPE_INIT="FETCH_VEHICLE_TRANSMISSIONTYPE_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_TRANSMISSIONTYPE_SCREEN =
'INIT_CREATE_VEHICLE_TRANSMISSIONTYPE_SCREEN';

export const CREATE_VEHICLE_TRANSMISSIONTYPE = {
START: 'CREATE_VEHICLE_TRANSMISSIONTYPE_START',
SUCCESS: 'CREATE_VEHICLE_TRANSMISSIONTYPE_SUCCESS',
ERROR: 'CREATE_VEHICLE_TRANSMISSIONTYPE_ERROR',
};

export const EDIT_VEHICLE_TRANSMISSIONTYPE = {
START: 'EDIT_VEHICLE_TRANSMISSIONTYPE_START',
SUCCESS: 'EDIT_VEHICLE_TRANSMISSIONTYPE_SUCCESS',
ERROR: 'EDIT_VEHICLE_TRANSMISSIONTYPE_ERROR',
};

export const FETCH_VEHICLE_TRANSMISSIONTYPE_DETAIL = {
  START: 'FETCH_VEHICLE_TRANSMISSIONTYPE_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_TRANSMISSIONTYPE_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_TRANSMISSIONTYPE_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_TRANSMISSIONTYPE = {
  START: 'EXPORT_VEHICLE_TRANSMISSIONTYPE_START',
  SUCCESS: 'EXPORT_VEHICLE_TRANSMISSIONTYPE_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_TRANSMISSIONTYPE_ERROR',
};
export const VEHICLE_MODELDD = {
  START: 'VEHICLE_MODELDD_START',
  SUCCESS: 'VEHICLE_MODELDD_SUCCESS',
  ERROR: 'VEHICLE_MODELDD_ERROR',
};

export const VEHICLE_TRANSMISSIONTYPE_DD = {
  START: 'VEHICLE_TRANSMISSIONTYPE_DD_START',
  SUCCESS: 'VEHICLE_TRANSMISSIONTYPE_DD_SUCCESS',
  ERROR: 'VEHICLE_TRANSMISSIONTYPE_DD_ERROR',
};

export const DELETE_VEHICLE_TRANSMISSIONTYPE = {
  START: 'DELETE_VEHICLE_TRANSMISSIONTYPE_START',
  SUCCESS: 'DELETE_VEHICLE_TRANSMISSIONTYPE_SUCCESS',
  ERROR: 'DELETE_VEHICLE_TRANSMISSIONTYPE_ERROR',
};

export const VEHICLE_TRANSMISSIONTYPE_SAVE_TABLE_STATE = 'VEHICLE_TRANSMISSIONTYPE_SAVE_TABLE_STATE';